import { changeVehicleApplyBusinessRules, changeVehicleGetPolicy } from '@/constants/forms-api.const';
import { RequestServices as _http } from '../common/request.services';
import { IServiceResponse } from '@/interfaces/entities';
import {
  ApplyRulesRequestOfChangeVehicleUpdateModel,
  ApplyRulesResponseOfChangeVehicleViewModel,
  InsurancePolicy,
} from '@/interfaces';
export const ChangeVehicleDetailsService = {
  /**
   * Get Policy
   *
   * @param quoteSessionId
   */
  getPolicy(quoteSessionId: string): Promise<IServiceResponse<InsurancePolicy>> {
    return _http.HttpGet(changeVehicleGetPolicy.replace('{0}', quoteSessionId));
  },

  /**
   * Apply Business Rules
   *
   * @param request
   */
  applyBusinessRules(
    request: ApplyRulesRequestOfChangeVehicleUpdateModel
  ): Promise<IServiceResponse<ApplyRulesResponseOfChangeVehicleViewModel>> {
    return _http.HttpPost(changeVehicleApplyBusinessRules, request);
  },
};
